<template>
  <div
    class="group flex size-full flex-col font-roboto text-new-black shadow-none"
  >
    <img
      v-lazy-load
      :src="getSrc"
      :alt="data?.image?.alt || data?.title"
      class="w-full object-cover transition-all duration-300 group-hover:scale-125"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const { isDesktop, isPad, isMobile } = useBreakpoint();
//     // getSrc() {
//     //   return (
//     //     (this.isDesktop && this.data?.image?.desktop) ||
//     //     (this.isPad && this.data?.image?.desktop) ||
//     //     (this.isMobile && this.data?.image?.mobile) ||
//     //     this.data?.image?.src ||
//     //     this.data?.image?.preview ||
//     //     this.data?.test_data?.images[0]?.src
//     //   );
//     // },
const getSrc = computed(() => {
  const src =
    (isDesktop.value && props.data?.image?.desktop) ||
    (isPad.value && props.data?.image?.desktop) ||
    (isMobile.value && props.data?.image?.mobile) ||
    props.data?.image?.src ||
    props.data?.image?.preview ||
    props.data?.test_data?.images[0]?.src;
  return src;
});
</script>

<style lang="scss" scoped>
.teacher-category:nth-child(1n) .type-tile {
  @apply bg-[#008FAD14] text-[#008FAD];
}
.teacher-category:nth-child(2n) .type-tile {
  @apply bg-[#1C6BEF14] text-[#1C6BEF];
}
.teacher-category:nth-child(3n) .type-tile {
  @apply bg-[#07ADA414] text-[#07ADA4];
}
.teacher-category:nth-child(4n) .type-tile {
  @apply bg-[#EA4B1D14] text-[#EA4B1D];
}
</style>
